import * as Sentry from '@sentry/react'

const generateThumbnailFromPreview = (scale = 1.0, quality = 0.92) =>
    new Promise((resolve, reject) => {
        try {
            const artCanvas = document.getElementById('PreviewCanvas')

            if (!artCanvas) {
                throw new Error('No canvas data source')
            }

            const thumbCanvas = document.createElement('canvas')
            thumbCanvas.width = scale * artCanvas.width
            thumbCanvas.height = scale * artCanvas.height

            const thumbCanvasContext = thumbCanvas.getContext('2d')

            thumbCanvasContext.scale(scale, scale)
            thumbCanvasContext.drawImage(artCanvas, 0, 0)
            thumbCanvasContext.scale(1, 1)

            let imageIsBlack = true
            const imgData = thumbCanvasContext.getImageData(0, 0, thumbCanvas.width, thumbCanvas.height)
            const { data } = imgData
            for (let i = 0; i < data.length; i += 4) {
                const r = data[i]
                const g = data[i + 1]
                const b = data[i + 2]
                imageIsBlack = r === 0 && g === 0 && b === 0
                if (!imageIsBlack) {
                    break
                }
            }

            const thumbDataUrl = thumbCanvas.toDataURL('image/jpeg', quality)

            if (imageIsBlack) {
                Sentry.captureEvent({
                    message: 'Black screenshot',
                })
            }

            resolve({
                thumbDataUrl,
                imageIsBlack,
            })
        } catch (error) {
            reject(error)
        }
    })

export default generateThumbnailFromPreview
